import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RestApiService } from '../../../../services/api/rest-api.service';
import {
  RemoteControlDisplayDataModel,
  RemoteControlPressButtonDataModel,
} from '../remote-control.model';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  private restApiService: RestApiService;

  constructor(restApiService: RestApiService) {
    this.restApiService = restApiService;
  }

  public getDisplay(
    terminalVid: string
  ): Observable<RemoteControlDisplayDataModel> {
    return this.restApiService.getRemoteControlDisplay(terminalVid);
  }

  public pressButton(
    terminalVid: string,
    buttonId: number
  ): Observable<RemoteControlPressButtonDataModel> {
    return this.restApiService.getRemoteControlPressButton(
      terminalVid,
      buttonId
    );
  }
}
